import React from 'react';

export const chooseFixIcon = (
	<g>
		<circle cx="20" cy="20" r="20" fill="#fff" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M23.663 11.773A9 9 0 1 0 29 20v-.919a1 1 0 1 1 2 0V20a11.002 11.002 0 0 1-14.812 10.313 10.999 10.999 0 1 1 8.289-20.366 1 1 0 1 1-.814 1.826Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M30.707 11.293a1 1 0 0 1 0 1.414l-10 10.01a1 1 0 0 1-1.414 0l-3-3a1 1 0 0 1 1.414-1.414L20 20.595l9.293-9.302a1 1 0 0 1 1.414 0Z"
			fill="currentColor"
		/>
	</g>
);

export const choosePayIcon = (
	<g>
		<circle cx="20" cy="20" r="20" fill="#fff" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 15a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v2h-2v-2a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h3.857v2H11a3 3 0 0 1-3-3v-6Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14 19a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H17a3 3 0 0 1-3-3v-6Zm3-1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H17Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M23 21a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z"
			fill="currentColor"
		/>
	</g>
);

export const chooseTeamIcon = (
	<g>
		<circle cx="20" cy="20" r="20" fill="#fff" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M18 15a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-9 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm16 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm-5 2a5.995 5.995 0 0 0-5.035 2.735A4.5 4.5 0 0 0 8 26.5V29h24v-2.5a4.5 4.5 0 0 0-6.965-3.765A5.995 5.995 0 0 0 20 20Zm5.995 5.764a6.008 6.008 0 0 0-.152-1.136A2.5 2.5 0 0 1 30 26.5v.5h-4v-1a6.14 6.14 0 0 0-.005-.236ZM24 25.897A4 4 0 0 0 16 26v1h8v-1l-.001-.103ZM12.5 24c.636 0 1.216.236 1.658.628A6.014 6.014 0 0 0 14 26v1h-4v-.5a2.5 2.5 0 0 1 2.5-2.5Z"
		/>
	</g>
);

export const chooseProtectIcon = (
	<g>
		<circle cx="20" cy="20" r="20" fill="#fff" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M19.683 8.05a1 1 0 0 1 .633 0l8.997 3a1 1 0 0 1 .684.949l.001 2.25L30 21c0 3.498-2.595 6.258-4.886 8.04a25.465 25.465 0 0 1-4.59 2.82l-.084.04-.023.01-.007.003h-.002s-.002.001-.408-.912l-.406.913-.004-.001-.006-.003-.024-.01-.084-.04a24.304 24.304 0 0 1-1.368-.704 25.472 25.472 0 0 1-3.222-2.116C12.595 27.257 10 24.497 10 20.999c0-3 0-5.25.002-6.75V12a1 1 0 0 1 .684-.948l8.998-3ZM12 12.72v1.53L11.998 21c0 2.503 1.905 4.742 4.114 6.46A23.48 23.48 0 0 0 20 29.892a23.473 23.473 0 0 0 3.886-2.431C26.095 25.74 28 23.502 28 21v-6.75l-.002-1.53L20 10.054l-7.998 2.666ZM20 31l-.406.913c.258.115.554.115.812 0L20 31Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16.292 18.242a1 1 0 0 1 1.414 0l1.415 1.414 3.535-3.535a1 1 0 1 1 1.414 1.414l-4.95 4.95-2.828-2.829a1 1 0 0 1 0-1.414Z"
			fill="currentColor"
		/>
	</g>
);
